import { createAction, props } from '@ngrx/store';
import { IGetBulkEmployeeUpdateFromExcelStatusResponse } from '../models/get-bulk-employee-update-from-excels-status.model';

export const getWSPayrollUpdateFromExcelsStatus = createAction(
  '[WSPayrollUpload] Load GetWSPayrollUpdateFromExcelStatus',
  props<{ businessId: string; bulkImportInviteHistoryId: string; noLoader: boolean }>()
);

export const getWSPayrollUpdateFromExcelsStatusSuccess = createAction(
  '[WSPayrollUpload] Load GetWSPayrollUpdateFromExcelStatus Success',
  props<{ response: IGetBulkEmployeeUpdateFromExcelStatusResponse }>()
);

export const getWSPayrollUpdateFromExcelsStatusFailure = createAction(
  '[WSPayrollUpload] Load GetWSPayrollUpdateFromExcelStatus Failure',
  props<{ error: Error | any }>()
);
